import Swiper, { Navigation } from 'swiper';

const swiperSlider = Array.from(document.querySelectorAll('.swiperSlider'));

if (swiperSlider.length) {
    swiperSlider.forEach((slider) => {
        const sliderSwiper = slider.querySelector('.swiper');
        const nextEl = slider.querySelector('.swiper-button-next');
        const prevEl = slider.querySelector('.swiper-button-prev');
        let config = {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 2.3,
            breakpoints: {
                600: {
                    slidesPerView: 2.3,
                    spaceBetween: 42,
                },
                980: {
                    slidesPerView: 3,
                    spaceBetween: 42,
                },
            },
            navigation: {
                nextEl,
                prevEl,
            },
        };

        if (sliderSwiper.classList.contains('related')) {
            config = {
                ...config,
                slidesPerView: 1,
                breakpoints: {
                    750: {
                        slidesPerView: 2.3,
                        spaceBetween: 42,
                    },
                    980: {
                        slidesPerView: 3,
                        spaceBetween: 42,
                    },
                },
                spaceBetween: 0,
            };
        }

        const swiper = new Swiper(sliderSwiper, config);

        const cards = Array.from(sliderSwiper.querySelectorAll('.card__secondary'));

        if (!cards.length) {
            return;
        }

        const tallestCard = cards.reduce((acc, card) => {
            return Math.max(acc, card.clientHeight);
        }, 0);

        nextEl.style.top = `${tallestCard / 2}px`;
        prevEl.style.top = `${tallestCard / 2}px`;
    });
}
